import Box from '@mui/material/Box'
import { CSSProperties } from 'react'

import { colors } from 'variables'

export interface Props {
  title: string
  children: React.ReactNode
}

export default function AnswerLayoutComponent(props: Props) {
  return (
    <Box style={containerStyle}>
      {/*header*/}
      <Box style={headerStyle}>{props.title}</Box>

      {/*content*/}
      <Box style={contentStyle}>{props.children}</Box>
    </Box>
  )
}

const containerStyle: CSSProperties = {
  display: 'flex',
  height: '100svh', // 検索アドレスなど抜きの高さ
  flexDirection: 'column',
}

const headerStyle: CSSProperties = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-end',
  height: '100px',
  color: 'white',
  fontSize: '20px',
  fontWeight: 'bold',
  backgroundColor: colors.PRIMARY_COLOR,
  padding: '16px',
  boxSizing: 'border-box',
}

const contentStyle: CSSProperties = {
  flex: 1,
  overflow: 'hidden',
}
